import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router'
import { Injectable } from '@angular/core'
import { ReplaySubject } from 'rxjs'

/**
 * gets the base path of the module, this differs per parent module implementing
 * the module
 */
@Injectable()
export class BasePathResolver implements Resolve<string> {
    basePath$ = new ReplaySubject(1)

    constructor() {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): string {
        const baseIndex = route.pathFromRoot.findIndex(
            ({ routeConfig }) => routeConfig && routeConfig.resolve && routeConfig.resolve.basePath
        )

        const basePath =
            '/' +
            route.pathFromRoot
                .filter((value, index) => index <= baseIndex)
                .map(({ url }) =>
                    url
                        .map(({ path }) => path)
                        .filter(v => !!v)
                        .join('/')
                )
                .filter(v => !!v)
                .join('/')

        this.basePath$.next(basePath)

        return basePath
    }
}
